import { Page, PrivacySettingsContent } from '@desp-aas/desp-ui-fwk';
import Navigation from '../../components/Navigation/Navigation';
import { GDPR_CONSENT_CONFIG } from '../../utils/gdpr';
import './PrivacySettingsPage.css';


export const PrivacySettingsPage = () => {
    return <Page id="privacy-settings-page">
        <Navigation />
        <PrivacySettingsContent consentConfig={GDPR_CONSENT_CONFIG} />
        
    </Page>
};
